import { TableColumn } from 'element-ui'
import Vue from 'vue'

export default Vue.extend({
  name: 'AutoTableColumn',
  extends: TableColumn, // 指定继承组件
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {
    updateAutoWidth() {
      // if (!this.$attrs.autoWidth) return
      setTimeout(() => {
        const columnComponent = this.$vnode.componentInstance
        // 获取 el-table 组件的 DOM 元素
        const tableComponent = columnComponent.owner
        const tableEl = tableComponent.$el

        // 获取 el-table 组件中每一列的 DOM 元素
        const tdEls = Array.from(
          tableEl.querySelectorAll(`.${columnComponent.columnId} .cell`),
        )
        const maxWidth = tdEls.reduce((maxWidth, tdEl) => {
          tdEl.style.width = 'fit-content'
          tdEl.style.whiteSpace = 'nowrap'
          const parent = tdEl.parentNode
          const paddingLeft = Number(
            window.getComputedStyle(parent).paddingLeft.split('px')[0],
          )
          const paddingRight = Number(
            window.getComputedStyle(parent).paddingRight.split('px')[0],
          )
          const offsetWidth = tdEl.offsetWidth
          tdEl.style.width = null
          tdEl.style.whiteSpace = null
          return Math.max(
            maxWidth,
            offsetWidth + paddingLeft + paddingRight + 1,
          )
        }, 0)
        columnComponent.$set(columnComponent.columnConfig, 'width', maxWidth)
        columnComponent.owner.store.scheduleLayout(true)
      }, 0)
    },
  },
  watch: {
    'owner.data': {
      handler() {
        this.updateAutoWidth()
      },
      immdiate: true,
    },
  },
  updated() {
    this.updateAutoWidth()
  },
  mounted() {
    this.$nextTick(this.updateAutoWidth)
  },
})
